import { render, staticRenderFns } from "./HeaderCommon.vue?vue&type=template&id=788dd90f&"
import script from "./HeaderCommon.vue?vue&type=script&lang=js&"
export * from "./HeaderCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports